import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getBulkUpdateItemsModel = createSelector(
    getModel,
    (model) => model.bulkUpdateItems,
);

export const getIsFetchingBulk = createSelector(
    getBulkUpdateItemsModel,
    (model) => model.isFetching,
);

export const getFilterData = createSelector(
    getModel,
    (model) => model.filterData,
);

export const getAttachmentsModel = createSelector(
    getModel,
    (model) => model.filterAttachments,
);

export const getAttachmentsData = createSelector(
    getAttachmentsModel,
    (model) => model.data.data,
);

export const getAttachmentsErrors = createSelector(
    getAttachmentsModel,
    (model) => model.errors,
);

export const getIsFetchingAttachments = createSelector(
    getAttachmentsModel,
    (model) => model.isFetching,
);

export const getAttachmentsPagination = createSelector(
    getAttachmentsModel,
    (model) => model.data.pagination || {},
);

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);
